import React from "react"

export default () => (
  <footer className="footer footer--dark">
    <div className="container">
      <div className="text--center">
        <span> built with 💚 by </span>
        <a
          href="https://www.ui5cn.com/"
          rel="noopener noreferrer"
          target="_blank"
        >
          @UI5CN
        </a>
      </div>
    </div>
  </footer>
)
